export default __webpack_public_path__ + "static/media/trophy.88f526e3.svg";